import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {StayInformedDialogComponent} from '../../dialogs/stay-informed-dialog/stay-informed-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    // this.router.events.subscribe((evt) => {
    //
    // });
  }

  stayInformed() {
    this.dialog.open(StayInformedDialogComponent, {});
  }

}
